import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { days } from 'app/pages/subscription/models/subscription';

export function localiseDayOfWeek(dayOfWeek: string, locale: string): string {
  const allDays: readonly unknown[] = days.map((d) => d.toLowerCase());

  const index = allDays.indexOf(dayOfWeek.toLowerCase());

  if (index === -1) {
    return dayOfWeek;
  }

  const date = new Date();
  date.setDate(date.getDate() - date.getDay()); // set day of week to sunday
  date.setDate(date.getDate() + index); // set day of week to param
  return date.toLocaleDateString(locale, { weekday: 'long' })
}

@Pipe({
  name: 'weekDay',
})
export class WeekDayPipe implements PipeTransform {
  constructor(
    @Inject(LOCALE_ID) private locale: string,
  ) {}

  transform(value: string): string {
    return localiseDayOfWeek(value, this.locale);
  }
}
